<app-navbar (darkModeToggleEvent)="toggleDarkMode($event)"></app-navbar>
<div class="mat-app-background" style="height: 100vh">
  <router-outlet></router-outlet>
</div>
